import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';

const AssignChangeSetModal = ({ show, onHide, onSubmit, claimGroup, title }) => {
  const { t } = useTranslation();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);

  const eligibleUsers = [
    claimGroup?.admin,
    ...(claimGroup?.consultant_roles?.map((r) => r.user) || []),
  ].filter(
    (user, index, self) => user && index === self.findIndex((u) => u.id === user.id)
  );

  useEffect(() => {
    setSaveBtnDisabled(!selectedUserId);
  }, [selectedUserId]);

  const handleSubmit = async (sendEmail) => {
    if (!selectedUserId) return;

    await onSubmit(selectedUserId, sendEmail);
    setSelectedUserId(null);
    setSaveBtnDisabled(true);
  };

  return (
    <Modal
      size="xl"
      show={show}
      title={title || t('assign_to_user')}
      onHide={onHide}
      renderBody={() => (
        <>
          {/* Section 1: Assign and send email */}
          <Card className="mb-3 p-3">
            <h5>{t('assign_and_send_email')}</h5>
            <p>{t('Select a user to assign the change set and send an email notification.')}</p>

            <Form>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={4}>{t('select_user')}</Form.Label>
                <Col md={8}>
                  {eligibleUsers.map((user) => (
                    <Form.Check
                      type="radio"
                      key={user.id}
                      label={`${user.first_name} ${user.last_name} (${user.email})`}
                      name="assignedUser"
                      value={user.id}
                      checked={selectedUserId === user.id}
                      onChange={() => setSelectedUserId(user.id)}
                    />
                  ))}
                </Col>
              </Form.Group>
            </Form>

            <div className="text-end">
              <Button
                variant="info"
                iconPosition="left"
                icon="mail"
                disabled={saveBtnDisabled}
                onClick={() => handleSubmit(true)}
              >
                {t('assign_and_send_email')}
              </Button>
            </div>
          </Card>

          {/* Section 2: Assign without email */}
          <Card className="p-3">
            <h5>{t('assign_without_sending_email')}</h5>
            <p>{t("Assign the change set without sending an email. You don't need to select a user for this.")}</p>

            <div className="text-end">
              <Button
                variant="secondary"
                disabled={saveBtnDisabled}
                onClick={() => handleSubmit(false)}
              >
                {t('assign_without_sending_email')}
              </Button>
            </div>
          </Card>
        </>
      )}
    />
  );
};

export default AssignChangeSetModal;
